export default __webpack_public_path__ + "static/media/poster-colombia.656f6461.png";